/**
 * Shared item display helpers for invoice templates.
 *
 * Unit:            unit object → product.units (sale item API) → plain unit string
 * selected_mapping: mobile vertical variants / parameters, shown as "label : value"
 * warranty_date:    mobile vertical warranty end date, shown as "Warranty till : DD-MM-YYYY"
 */

/** Unit name for an invoice item, e.g. "Piece". Returns '' when no unit is known. */
export function getItemUnitName(item: any): string {
  const unit = item?.unit;
  return String(
    unit?.name ||
    item?.product?.units?.name ||
    (typeof unit === 'string' ? unit : '') ||
    '',
  ).trim();
}

/** "Warranty till : DD-MM-YYYY" from item.warranty_date (YYYY-MM-DD), or null when not set */
export function getWarrantyLine(item: any): string | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(item?.warranty_date || ''));
  return match ? `Warranty till : ${match[3]}-${match[2]}-${match[1]}` : null;
}

/** Variants then parameters from selected_mapping as "label : value", then the warranty line — skips entries with an empty label or value */
export function getSelectedMappingLines(item: any): string[] {
  const warranty = getWarrantyLine(item);
  const mapping = item?.selected_mapping;
  if (!mapping) return warranty ? [warranty] : [];
  const hasText = (v: any) => v !== null && v !== undefined && String(v).trim() !== '';
  const lines: string[] = [];
  (mapping.variants || []).forEach((v: any) => {
    if (hasText(v?.variant_label) && hasText(v?.variant_value)) {
      lines.push(`${String(v.variant_label).trim()} : ${String(v.variant_value).trim()}`);
    }
  });
  (mapping.parameters || []).forEach((p: any) => {
    if (hasText(p?.parameter_label) && hasText(p?.parameter_value)) {
      lines.push(`${String(p.parameter_label).trim()} : ${String(p.parameter_value).trim()}`);
    }
  });
  if (warranty) lines.push(warranty);
  return lines;
}
